"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
require("mapbox-gl/dist/mapbox-gl.css");
var _react = _interopRequireWildcard(require("react"));
var _types = require("./types");
var _reactIntersectionObserver = require("react-intersection-observer");
var _reactMapGl = _interopRequireWildcard(require("react-map-gl"));
var _geojsonExtent = _interopRequireDefault(require("@mapbox/geojson-extent"));
var _labelFormatter = require("../utils/label-formatter");
var _HorizontalRange = _interopRequireDefault(require("../components/legends/HorizontalRange"));
var _HorizontalLegend = require("../components/legends/HorizontalLegend");
var _ChartDescription = _interopRequireDefault(require("../components/ChartDescription"));
var _useColor = require("../hooks/useColor");
var _constants = require("../constants");
var _BaseMap = require("./BaseMap.styled");
var _ChartTooltip = require("../components/ChartTooltip.styled");
var _chartOperations = require("../utils/chart-operations");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const BaseMap = /*#__PURE__*/(0, _react.memo)(props => {
  const {
    chart,
    boundaries,
    chartColors,
    layout,
    animate,
    isPreview,
    children,
    sortedValues,
    createPopup,
    flatColorStops,
    areas,
    filterComponent
  } = props;
  const colorConfig = chart.colors || chartColors;
  if (colorConfig && !colorConfig.settings) {
    colorConfig.settings = {
      direction: "ascending",
      divergingMidPoint: 0,
      steps: 6
    };
  }
  const {
    yCol,
    yFormat,
    tooltipFormat,
    tooltipCol,
    legend,
    componentProps,
    regions,
    aspectRatio,
    dataView
  } = chart;
  const {
    columns
  } = dataView;
  const {
    mapStyle = "mapbox://styles/mapbox/light-v10",
    colorScheme = "sequential",
    mainDisplay = "boundary_thin",
    containerDisplay = "none",
    peersDisplay = "none"
  } = componentProps;
  const [popup, setPopup] = (0, _react.useState)(null);
  const [mapLoaded, setMapLoaded] = (0, _react.useState)(false);
  const {
    colorPalette
  } = (0, _useColor.useColor)(colorConfig, colorScheme);
  const mapRef = (0, _react.useRef)();
  const {
    ref,
    inView
  } = (0, _reactIntersectionObserver.useInView)({
    threshold: 0.1,
    triggerOnce: true
  });
  const [viewState, setViewState] = (0, _react.useState)({
    latitude: 39.833333,
    longitude: -98.583333,
    zoom: 3
  });
  const vBoundaries = boundaries[regions.setup.version];
  let peers = null;
  if (peersDisplay !== "none" && regions.setup.sorroundings !== "none" && regions.setup.container !== "none" && regions !== null && regions !== void 0 && regions.peers) {
    const peerRegions = regions.peers.map(geoId => vBoundaries[geoId]).filter(Boolean);
    peers = {
      type: "FeatureCollection",
      features: peerRegions.map(region => region.feature)
    };
  }
  let roads = null;
  // if (regions.setup.roads !== "none" && regions?.roads) {
  //   // roads = {
  //   //   type: "FeatureCollection",
  //   //   features: mapRegions.roads[regionSetup.roads].map((road) => road.feature),
  //   // };
  // }

  (0, _react.useEffect)(() => {
    if (mapRef.current === null || !areas || areas.features.length === 0) {
      return;
    }
    if (animate && inView) {
      const bounds = (0, _geojsonExtent.default)(areas);
      mapRef.current.fitBounds(bounds, {
        padding: 20,
        speed: 2
      });
    }
    if (!animate) {
      const bounds = (0, _geojsonExtent.default)(areas);
      mapRef.current.fitBounds(bounds, {
        padding: 20,
        animate: false
      });
    }
  }, [inView, animate, mapLoaded, areas]);
  const handleMapLoad = e => {
    setMapLoaded(true);
  };
  const handleMouseLeave = e => {
    setPopup(null);
  };
  const handleMouseMove = e => {
    var _e$features, _e$features$, _e$features$$properti;
    if (!((_e$features = e.features) !== null && _e$features !== void 0 && (_e$features$ = _e$features[0]) !== null && _e$features$ !== void 0 && (_e$features$$properti = _e$features$.properties) !== null && _e$features$$properti !== void 0 && _e$features$$properti[_constants.COL_GEO_ID])) {
      setPopup(null);
      return;
    }
    const popupData = createPopup(e.features[0].properties, mapRef);
    if (popupData) {
      setPopup(popupData);
    }
  };
  let legendLabels = [];
  if (colorScheme === "categorical" && legend === "horizontal" && sortedValues.length > 0) {
    legendLabels = sortedValues.map(key => {
      var _chart$dataView$colum, _chart$dataView$colum2;
      return {
        key,
        label: ((_chart$dataView$colum = chart.dataView.columns[yCol]) === null || _chart$dataView$colum === void 0 ? void 0 : (_chart$dataView$colum2 = _chart$dataView$colum.categories[key]) === null || _chart$dataView$colum2 === void 0 ? void 0 : _chart$dataView$colum2.label) || ""
      };
    }).sort((a, b) => flatColorStops.findIndex(s => s === a.key) - flatColorStops.findIndex(s => s === b.key));
  }
  const displayLayers = {
    boundary_thick: /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, {
      type: "line",
      paint: {
        "line-width": 3,
        "line-color": "#333",
        "line-opacity": 0.7
      }
    }),
    boundary_thin: /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, {
      type: "line",
      paint: {
        "line-width": 1,
        "line-color": "#333",
        "line-opacity": 0.4
      }
    }),
    boundary_prominent: /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, {
      type: "line",
      paint: {
        "line-width": 3,
        "line-color": "#ff6600",
        "line-opacity": 0.9
      }
    }),
    area_light: /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, {
      type: "fill",
      paint: {
        "fill-color": "#666",
        "fill-opacity": 0.3
      }
    }),
    area_dark: /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, {
      type: "fill",
      paint: {
        "fill-color": "#333",
        "fill-opacity": 0.8
      }
    }),
    area_prominent: /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, {
      type: "fill",
      paint: {
        "fill-color": "#ff6600",
        "fill-opacity": 0.3
      }
    })
  };
  if (!vBoundaries) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_BaseMap.BaseMapWrapper, {
    ref: ref
  }, filterComponent, /*#__PURE__*/_react.default.createElement(_reactMapGl.default, (0, _extends2.default)({
    ref: mapRef
  }, viewState, {
    onMove: evt => {
      setViewState(evt.viewState);
    },
    style: {
      width: "100%",
      aspectRatio: (0, _chartOperations.ratioToNumber)(aspectRatio),
      margin: "2em auto 1em auto"
    },
    mapStyle: mapStyle,
    mapboxAccessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
    preserveDrawingBuffer: true,
    scrollZoom: false,
    interactiveLayerIds: ["".concat(chart.id, "|interactive-layer")],
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
    onLoad: handleMapLoad
  }), /*#__PURE__*/_react.default.createElement(_reactMapGl.ScaleControl, {
    unit: "imperial"
  }), (layout === "screen" || isPreview) && /*#__PURE__*/_react.default.createElement(_reactMapGl.NavigationControl, null), containerDisplay.startsWith("area_") && (regions === null || regions === void 0 ? void 0 : regions.container) && vBoundaries[regions.container] && /*#__PURE__*/_react.default.createElement(_reactMapGl.Source, {
    id: "".concat(chart.id, "|container"),
    type: "geojson",
    data: vBoundaries[regions.container].feature
  }, displayLayers[containerDisplay]), peersDisplay.startsWith("area_") && peers && /*#__PURE__*/_react.default.createElement(_reactMapGl.Source, {
    id: "".concat(chart.id, "|peers"),
    type: "geojson",
    data: peers
  }, displayLayers[peersDisplay]), mainDisplay.startsWith("area_") && (regions === null || regions === void 0 ? void 0 : regions.main) && vBoundaries[regions.main] && /*#__PURE__*/_react.default.createElement(_reactMapGl.Source, {
    id: "".concat(chart.id, "|main"),
    type: "geojson",
    data: vBoundaries[regions.main].feature
  }, displayLayers[mainDisplay]), roads && /*#__PURE__*/_react.default.createElement(_reactMapGl.Source, {
    id: "".concat(chart.id, "|roads"),
    type: "geojson",
    data: roads
  }, /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, {
    type: "line",
    paint: {
      "line-width": 2,
      "line-color": "#ffd000",
      "line-opacity": 0.7
    }
  })), children, containerDisplay.startsWith("boundary_") && (regions === null || regions === void 0 ? void 0 : regions.container) && vBoundaries[regions.container] && /*#__PURE__*/_react.default.createElement(_reactMapGl.Source, {
    id: "".concat(chart.id, "|container"),
    type: "geojson",
    data: vBoundaries[regions.container].feature
  }, displayLayers[containerDisplay]), peersDisplay.startsWith("boundary_") && peers && /*#__PURE__*/_react.default.createElement(_reactMapGl.Source, {
    id: "".concat(chart.id, "|peers"),
    type: "geojson",
    data: peers
  }, displayLayers[peersDisplay]), mainDisplay.startsWith("boundary_") && (regions === null || regions === void 0 ? void 0 : regions.main) && vBoundaries[regions.main] && /*#__PURE__*/_react.default.createElement(_reactMapGl.Source, {
    id: "".concat(chart.id, "|main"),
    type: "geojson",
    data: vBoundaries[regions.main].feature
  }, displayLayers[mainDisplay]), popup && /*#__PURE__*/_react.default.createElement(_reactMapGl.Popup, {
    longitude: popup.lng,
    latitude: popup.lat,
    anchor: popup.anchor,
    closeButton: false,
    className: "tooltip-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_ChartTooltip.ChartTooltipTitle, {
    color: colorPalette.at(-1)
  }, popup.label), /*#__PURE__*/_react.default.createElement(_ChartTooltip.ChartTooltipBody, null, /*#__PURE__*/_react.default.createElement("em", null), /*#__PURE__*/_react.default.createElement("span", null, _labelFormatter.QuantitativeFormatter[tooltipFormat] ? _labelFormatter.QuantitativeFormatter[tooltipFormat](popup.tooltipValue) : tooltipFormat === _types.ChartCategoricalFormat.LABEL ? columns[tooltipCol].categories[popup.tooltipValue].label : popup.tooltipValue)))), colorScheme !== "categorical" && legend === "horizontal" && sortedValues.length >= 2 && /*#__PURE__*/_react.default.createElement(_HorizontalRange.default, {
    palette: colorPalette,
    min: sortedValues.at(0),
    mid: colorConfig.settings.divergingMidPoint,
    max: sortedValues.at(-1),
    format: yFormat
  }), colorScheme === "categorical" && legend === "horizontal" && /*#__PURE__*/_react.default.createElement(_HorizontalLegend.HorizontalLegend, {
    labels: legendLabels,
    palette: colorPalette,
    format: yFormat
  }), /*#__PURE__*/_react.default.createElement(_ChartDescription.default, {
    description: chart.description
  }));
});
var _default = BaseMap;
exports.default = _default;